module.exports = __webpack_public_path__ + "static/media/brand_mastercard.543bc93b.svg";